/**
 * @fileoverview Field-source legend order + labels.
 *
 * Split out of `SourceLegend.tsx` (react-refresh/only-export-components) —
 * the `source` values match the `data-field-source` attribute the chips
 * render with, so the CSS in `src/index.css` paints each swatch in the
 * right colour automatically. Help text is pulled from
 * `FIELD_SOURCE_STYLES` (single source of truth).
 */

import type { FieldSource } from "@/utils/precedents/classifyFieldSource";

export const SOURCE_LEGEND: ReadonlyArray<{
  source: FieldSource;
  label: string;
}> = [
  { source: "job", label: "From Job" },
  { source: "org", label: "From Org" },
  { source: "custom", label: "Custom" },
  { source: "template", label: "Unmapped" },
  { source: "manual", label: "Manual" },
  { source: "job_contact", label: "Job Contact" },
  { source: "job_contact_source", label: "Job Contact Data" },
  { source: "firm_contact", label: "Firm Contact" },
  { source: "firm_reference", label: "Firm Ref" },
];
